export default {
  REACT_APP_APPLICATION_ENVIRONMENT: process.env.REACT_APP_APPLICATION_ENVIRONMENT,
  REACT_APP_SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  REACT_APP_BASE_API_URL: process.env.REACT_APP_BASE_API_URL,
};
